module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Of course there are a few people to recognize who have helped this project come to fruition. Thank you to these wonderful people.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The late John Armijo, who was the historian for the New Mexico Film Office for many years. His support and knowledge was invaluable, as were the research papers he left me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My late friend Lew Cady, who was the first to believe in my writing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Author Max Evans, who not only helped start the nation’s first film office but also has had more kind words for my writing than anyone on the planet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charles Horak, the founder and former programmer of the Plaza Classic Film Festival, and photographer Robert Yee, for their ongoing support.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Keif Henley, co-owner of Albuquerque’s Guild Cinema, for his support and for hosting many of my Made in New Mexico screenings over the years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Barb Odell, for her amazing help with photographs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All of the folks in the audiences of any film screening that I have shared, in the past and in the future.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And of course, my wife, Sarah, for her polite toleration of all of the time I have spent on this project rather than learning how to do home repairs.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc40c2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgements.vue
// module id = 69
// module chunks = 0